import React from "react";
import {
  QuestionTooltip,
  QuestionTooltipSize,
  ShowMoreParagraph,
} from "component-library";

import { prepareHelper } from "./BasicInfoDetailsHelpers";

import "./BasicInfoDetails.scss";

export interface IBasicInfoDetailsProps {
  name: string;
  values: string[];
  hint?: string;
}

const COMPLEXION_TEXT_CHAR_LIMIT = 15;

export default class BasicInfoDetails extends React.PureComponent<IBasicInfoDetailsProps> {
  public render() {
    const { name, values, hint } = this.props;

    // currently only makeup needs the show more functionality; add to this list if more are needed
    const isShowMoreParagraph = name.toLowerCase().includes("complexion");
    const tooltip = prepareHelper(hint || "");

    return (
      <>
        <dt className="c-basic-info-details__name">
          {name}
          {hint && (
            <QuestionTooltip {...tooltip} size={QuestionTooltipSize.tiny} />
          )}
        </dt>
        <dd className="c-basic-info-details__values">
          {values.map((value, index) =>
            isShowMoreParagraph ? (
              <ShowMoreParagraph
                characterLimit={COMPLEXION_TEXT_CHAR_LIMIT}
                paragraphText={value}
                key={value + index}
                className="c-basic-info-details__value"
              />
            ) : (
              <div key={value + index} className="c-basic-info-details__value">
                {value}
              </div>
            )
          )}
        </dd>
      </>
    );
  }
}
